
import { get } from 'lodash';
const OKTA_URL = get(process.env,"REACT_APP_OKTA_URL","https://connectcdk-dev.oktapreview.com");

export const oktaUrls =  { 
    SESSION : OKTA_URL + "/api/v1/sessions/me",
    AUTHORIZE : OKTA_URL + "/oauth2/default/v1/authorize"
}